import axios from 'axios';
import endpointVersion from '@/helpers/endpoint-version';
import store from '@/store';
export const getTable = ({ preset, limit, page, orderBy, query, campaignId, sellerId, cluster, storeId, originSale, contactType, }) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    const startDate = store.getters.dates.startDate;
    const endDate = store.getters.dates.endDate;
    const serializedQuery = JSON.stringify(query);
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'POST',
        baseURL: endpointVersion('v3'),
        url: '/oto/sales/getTableSales',
        data: {
            brand: brand.id,
            preset,
            startDate,
            endDate,
            limit,
            page,
            orderBy,
            query: serializedQuery,
            campaignId,
            cluster,
            sellerId,
            storeId,
            originSale,
            contactType,
        },
    });
};
export const getTableTotalizers = ({ preset, query, campaignId, storeId, sellerId, cluster, originSale, contactType, }) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    const startDate = store.getters.dates.startDate;
    const endDate = store.getters.dates.endDate;
    const serializedQuery = JSON.stringify(query);
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'POST',
        baseURL: endpointVersion('v3'),
        url: '/oto/sales/getTableSales',
        data: {
            brand: brand.id,
            preset,
            startDate,
            endDate,
            campaignId,
            sellerId,
            storeId,
            cluster,
            originSale,
            contactType,
            query: serializedQuery,
            totalizer: true,
        },
    });
};
export const getTablePresets = () => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: `oto/sales/getTablePresets`,
        params: {
            brand: brand.id,
        },
    }).then(data => data?.data);
};
export const getExportTable = ({ fileType, metrics, preset, campaignId, storeId, sellerId, cluster, originSale, contactType, }) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    const startDate = store.getters.dates.startDate;
    const endDate = store.getters.dates.endDate;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'POST',
        baseURL: endpointVersion('v3'),
        url: '/oto/sales/getTableSales',
        data: {
            brand: brand.id,
            startDate,
            endDate,
            metrics,
            preset,
            export: fileType,
            campaignId,
            storeId,
            sellerId,
            cluster,
            originSale,
            contactType,
        },
    });
};
export const getTableMetrics = (preset) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: `/oto/sales/getTableMetrics`,
        params: {
            brand: brand.id,
            preset,
        },
    });
};
export const getExportJobDetails = (batchId) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: `/oto/engagement/getExportJobDetails`,
        params: {
            brand: brand.id,
            batchId,
        },
    });
};
export const postEditColumns = (metrics, preset, report) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'POST',
        baseURL: endpointVersion('v3'),
        url: '/config/putUserConfig',
        params: {
            brand: brand.id,
            metrics,
            preset,
            report,
        },
    });
};
export const getFilterContact = () => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: '/oto/sales/getFilterContact',
        params: {
            brand: brand.id,
        },
    });
};
export const getFilterSales = () => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: '/oto/sales/getFilterSelling',
        params: {
            brand: brand.id,
        },
    });
};
export const getSellers = () => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: `seller/getSellersSegmenter`,
        params: {
            brand: brand.id,
        },
    });
};
export const getStores = () => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: `360/performance/getStores`,
        params: {
            brand: brand.id,
        },
    });
};
export const getCampaigns = () => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    const { startDate, endDate } = store.getters.dates;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: `/campaign/getCampaignsReports`,
        params: {
            brand: brand.id,
            startDate,
            endDate,
        },
    });
};
export const getClusters = () => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: `/oto/engagement/getCluster`,
        params: {
            brand: brand.id,
        },
    });
};
export const getIndicators = ({ campaignId, sellerId, storeId, cluster, originSale, contactType }) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    const startDate = store.getters.dates.startDate;
    const endDate = store.getters.dates.endDate;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'POST',
        baseURL: endpointVersion('v3'),
        url: `/oto/sales/getIndicators`,
        data: {
            brand: brand.id,
            startDate,
            endDate,
            campaignId,
            sellerId,
            storeId,
            cluster,
            originSale,
            contactType,
        },
    });
};
